<template>
    <table class="w-100" border="1">
        <tr>
            <th colspan="3">{{ title }}</th>
        </tr>
        <tr v-for="item in items" :key="item.id">
            <td align="left">{{ item.date }}</td>
            <td align="right">{{ item.value | money }} EUR</td>
            <td align="center" width="1px"><i class="icon-close" style="cursor: pointer;" @click="deleteItem(item.id)"></i></td>
        </tr>
        <tr>
            <td colspan="3"></td>
        </tr>
        <tr>
            <td align="left"><b>Sum:</b></td>
            <td align="right" colspan="2"><b>{{ sum | money }} EUR</b></td>
        </tr>
        <tr>
            <td align="left"><input type="date" v-model="date" autocomplete="off"></td>
            <td align="right" colspan="2"><input type="text" v-model="value"></td>
        </tr>
        <tr>
            <td align="right" colspan="3"><button type="button" class="btn btn-lightest small" @click="storeItem()">Add</button></td>
        </tr>
    </table>
</template>
<script>
    import Xhr from '../../../core/xhr';

    export default {
        props: {
            pNumber: {
                type: String,
                required: true,
                default: ""
            },
            type: {
                type: String,
                default: ""
            },
            title: {
                type: String,
                required: true,
                default: ""
            }
        },

        data() {
            return {
                date: new Date().toISOString().split('T')[0],
                value: '',
                items: [],
                sum: 0,
            };
        },

        created() {
            this.getItems();
        },

        methods: {
            storeItem() {
                new Xhr({pNumber: this.pNumber, type: this.type, date: this.date, value: this.value}).post('/dagoadmin/k-t-o-list/storeItem').then(() => {
                    this.value = '';
                    this.date = new Date().toISOString().split('T')[0];
                    this.getItems();
                }).catch(() => {});
            },

            deleteItem(iid) {
                new Xhr({id: iid}).post('/dagoadmin/k-t-o-list/deleteItem').then((response) => {
                    this.getItems();
                }).catch(() => {});
            },

            getItems() {
                new Xhr({pNumber: this.pNumber, type: this.type}).post('/dagoadmin/k-t-o-list/getItems').then((response) => {
                    this.items = response.items;
                    this.sum = response.sum;

                    window.App.dispatcher.fire(
                        'chargeChange',
                        { charge: this.sum, type: this.type }
                    )
                }).catch(() => {});
            }
        },

        filters: {
            money(value) {
                return new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format((value));
            },
        }
    }
</script>
